import React from "react";
import "@/App.css";

// Section components
import Navbar from "./components/sections/Navbar";
import HeroSection from "./components/sections/HeroSection";
import AboutSection from "./components/sections/AboutSection";
import ServicesSection from "./components/sections/ServicesSection";
import TestimonialsSection from "./components/sections/TestimonialsSection";
import BlogSection from "./components/sections/BlogSection";
import ContactSection from "./components/sections/ContactSection";
import Footer from "./components/sections/Footer";
import WhatsAppButton from "./components/sections/WhatsAppButton";

function App() {
  return (
    <div className="App bg-warm-bg min-h-screen">
      {/* Navigation */}
      <Navbar />

      {/* Main Content */}
      <main>
        {/* Hero Section - Scroll Expansion */}
        <HeroSection />

        {/* About Section - Container Scroll 3D */}
        <AboutSection />

        {/* Services Section */}
        <ServicesSection />

        {/* Testimonials Section - Auto-scrolling Carousel */}
        <TestimonialsSection />

        {/* Blog Section - With Modal */}
        <BlogSection />

        {/* Contact Section - Form to WhatsApp */}
        <ContactSection />
      </main>

      {/* Footer */}
      <Footer />

      {/* Floating WhatsApp Button */}
      <WhatsAppButton />
    </div>
  );
}

export default App;
